// @flow

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { InputV2, InputConsumer, TextareaInput } from '@catalytic/catalytic-ui';
import { types } from '@catalytic/react-view';
import useFieldContext from './FieldContext';
import { useHandleBlur, useHandleChange } from './ViewHelpers';

const useStyles = makeStyles(theme => ({
  inputElement: theme.typography.monospace
}));

const CodeView = ({ schema: getSchema, setValue, value }: types.CodeView) => {
  const schema = getSchema();
  const fieldContext = useFieldContext();
  const {
    className,
    description,
    disabled,
    displayErrors,
    displayName,
    embedded,
    example,
    hasValidation,
    id,
    name,
    onBlur,
    onChange,
    readOnly,
    required,
    type
  } = fieldContext || {};
  const handleBlur = useHandleBlur({ onBlur, setValue, type });
  const handleChange = useHandleChange({ onChange, setValue, type });
  const classes = useStyles();
  const stringifiedValue =
    value && typeof value === 'object' ? JSON.stringify(value, null, 2) : value;

  return (
    <InputV2
      className={className}
      description={description}
      disabled={disabled}
      displayErrors={displayErrors}
      example={example}
      hasValidation={hasValidation}
      id={id}
      inputElementClassName={classes.inputElement}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={readOnly}
      schema={schema}
      title={displayName}
      type={type}
      value={stringifiedValue}
    >
      <InputConsumer>
        {props => (
          <TextareaInput
            defaultValue={stringifiedValue}
            embedded={embedded}
            id={id}
            name={name}
            required={required}
            {...props}
          />
        )}
      </InputConsumer>
    </InputV2>
  );
};
CodeView.displayName = 'CodeView';

export default React.memo<types.CodeView>(CodeView);
